import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const CancelAppointmentSkeleton = () => {
  return (
    <div className="pt-24 pb-16 px-4">
      <div className="container mx-auto max-w-lg">
        <Card>
          <CardHeader>
            {/* Titre */}
            <Skeleton className="h-7 w-64 mb-2" />
            {/* Description */}
            <Skeleton className="h-4 w-full max-w-md" />
          </CardHeader>
          <CardContent>
            {/* Zone des détails du rendez-vous */}
            <div className="mb-6 p-4 bg-muted/20 rounded-md">
              <Skeleton className="h-5 w-40 mb-3" />
              {/* Date */}
              <Skeleton className="h-4 w-48 mb-2" />
              {/* Horaire */}
              <Skeleton className="h-4 w-32 mb-4" />
              
              {/* Services réservés */}
              <Skeleton className="h-5 w-36 mb-2" />
              <div className="ml-4 space-y-2">
                <Skeleton className="h-4 w-56" />
                <Skeleton className="h-4 w-48" />
              </div>
            </div>
            
            {/* Question de confirmation */}
            <Skeleton className="h-4 w-72 mb-4" />
            
            {/* Boutons */}
            <div className="flex gap-3 justify-center">
              <Skeleton className="h-10 w-24 rounded-md" />
              <Skeleton className="h-10 w-44 rounded-md" />
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
